/**
 * Serwisy czasopism i wydawców stoją na własnych hostach (app-journal / app-publisher rozpoznają rekord
 * po nagłówku Host), więc z pola `domain` budujemy pełny adres. Hosty deweloperskie chodzą po http.
 */
const PROTOCOL_REGEX = /^https?:\/\//i
const INSECURE_HOST_REGEX = /(^|\.)(docker|local|localhost|test)(:\d+)?$/i

export const getExternalSiteUrl = (domain) => {
  const trimmedDomain = typeof domain === 'string' ? domain.trim() : ''

  if (!trimmedDomain) {
    return null
  }

  if (PROTOCOL_REGEX.test(trimmedDomain)) {
    return trimmedDomain
  }

  const protocol = INSECURE_HOST_REGEX.test(trimmedDomain) ? 'http' : 'https'

  return `${protocol}://${trimmedDomain}`
}

// Adres serwisu tylko dla rekordów z włączoną usługą hostingu (`serviceScope` w API).
export const getHostedSiteUrl = (entity) => (entity?.hostingEnabled ? getExternalSiteUrl(entity.domain) : null)
